'use client';
/* Built In Imports */
/* External Imports */
import { Box, useBreakpointValue } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';

/* Internal Imports */
/* Components */
import LazyLoadImageComponent from '@app-ps/Components/Ui/LazyLoadImageComponent';
import StructuredTextParser from '@app-ps/Utility/StructuredTextParser';
import config from '@config';

/* Internal Imports */
/* Components */

/**
 * @param {object} sectionContent
 * @param {Array} region - region.
 * @param {Array} lang - language.
 * @returns
 */
const Vision = ({ sectionContent, region, language }) => {
  const title = sectionContent.find(
    item => item._modelApiKey === 'section_title'
  )?.titleText;

  const titleSubtext = sectionContent.find(
    item => item._modelApiKey === 'structured_text'
  )?.body;
  // using dato url images

  const imagesUrl = [
    {
      url_id: 1,
      url: `${config.imgPath}/d/46272/1718949773-yoga-img.png`,
      size: {
        1330: { width: '204.75px', height: '321.75px' }, // Figma size for 1330px
        1920: { width: '321px', height: '504px' }, // Figma size for 1920px
      },
    },
    {
      url_id: 2,
      url: `${config.imgPath}/d/46272/1718949727-hand-drums-tabla.png`,
      size: {
        1330: { width: '174px', height: '166px' },
        1920: { width: '272px', height: '262px' },
      },
    },
    {
      url_id: 3,
      url: `${config.imgPath}/d/46272/1718949910-khathak-dance-img.png`,
      size: {
        1330: { width: '191px', height: '301px' },
        1920: { width: '301.03px', height: '472px' },
      },
    },

    {
      url_id: 4,
      url: `${config.imgPath}/d/46272/1718949656-vision-layer-dancer.png`,
      size: {
        1330: { width: '262.52px', height: '190.86px' },
        1920: { width: '411px', height: '300px' },
      },
    },
    {
      url_id: 5,
      url: `${config.imgPath}/d/46272/1718949750-kathak-dance-vision.png`,
      size: {
        1330: { width: '114.81px', height: '269.1px' },
        1920: { width: '180.29px', height: '422px' },
      },
    },
    {
      url_id: 6,
      url: `${config.imgPath}/d/46272/1718949884-veena-vision-img.png`,
      size: {
        1330: { width: '194.51px', height: '307.12px' },

        1920: { width: '305px', height: '481px' },
      },
    },
  ];

  const isMobile = useBreakpointValue({ base: false, lg: true });
  return (
    <Box
      textAlign="center"
      backgroundColor="#000000"
      p={{ base: '0 0 20rem', md: '0 0 18%', lg: '0 0 10%' }}
    >
      <Box
        backgroundImage={`url(${config.imgPath}/d/46272/1724185140-vision_background.jpg)`}
        backgroundSize={'cover'}
        backgroundPosition={'center'}
        backgroundRepeat="no-repeat"
        position="relative"
        width="100%"
        height={{ base: '40.625rem', md: '45.9375rem', '2xl': '59.813rem' }}
      >
        <Box
          textAlign="center"
          width={{ base: '100%', md: '100%', lg: '57%', '2xl': '51%' }}
          mx="auto"
          p={{ base: '4rem .5rem 10%', md: '8rem 2rem 0' }}
        >
          <Box
            as="h2"
            color={'#FEFAF6'}
            fontSize={{ base: '1.5rem', md: '2.625rem', '2xl': '3.25rem' }}
            lineHeight={{ base: '1.8rem', md: '3.15rem', '2xl': '3.9rem' }}
            letterSpacing={'0.16px'}
            fontFamily="var(--FedraSerifDisplay-Bold)"
            mb={{ base: '2rem', md: '3rem' }}
          >
            {title &&
              title.charAt(0).toUpperCase() + title.slice(1).toLowerCase()}
          </Box>
          {titleSubtext && (
            <StructuredTextParser
              str={render(titleSubtext?.value)}
              region={region}
              lang={language}
              letterSpacing="2%"
              color="#F1EDE9"
              paddingX={{ base: '1rem', sm: '0', '2xl': '6rem' }}
              textAlign="center"
              fontFamily="var(--FedraSansStd-book)"
              fontSize={{ base: '1.125rem', md: '1.5rem', '2xl': '1.75rem' }}
              lineHeight={{ base: '1.8rem', md: '2.4rem', '2xl': '2.8rem' }}
              fontWeight="400"
            />
          )}
        </Box>

        {imagesUrl && (
          <Box
            display="flex"
            width="100%"
            mt={{ base: '2rem', sm: '2rem', lg: '0' }}
            alignItems="end"
            justifyContent="space-between"
            position={{ base: 'static', lg: 'absolute' }}
            bottom={{ base: '-23%', sm: '-8rem', md: '-4rem' }}
            overflow="hidden"
          >
            {isMobile ? (
              <>
                {imagesUrl.map(image => {
                  return (
                    <LazyLoadImageComponent
                      key={image?.url_id}
                      src={image?.url}
                      alt="vision-images"
                      // width={image?.width}
                      // height={image?.height}
                      width={{
                        xl: image?.size['1330'].width,
                        base: `calc(100% / ${imagesUrl.length})`,
                        '2xl': image?.size['1920'].width,
                      }} // 'base' refers to smaller screens, 'xl' is for larger screens like 1920px
                      maxH={{ lg: '263px', xl: '100%', '2xl': '100%' }}
                      objectFit={{ base: 'contain' }}
                      height={{
                        base: 'auto',

                        xl: image?.size['1330'].height,
                        '2xl': image?.size['1920'].height,
                      }}
                    />
                  );
                })}
              </>
            ) : (
              <LazyLoadImageComponent
                src={`${config.imgPath}/d/46272/1718949750-kathak-dance-vision.png`}
                alt="vision-images"
                // width="auto"
                width="174.74px"
                height="409px"
                mx="auto"
              />
            )}
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default Vision;
